import { getChannelAudio } from '../utils/getAudio';

import { useCurrentSportStream } from './useCurrentSportStream';

export const useAudio = (contentId: string) => {
    const stream = useCurrentSportStream(contentId);

    return getChannelAudio(stream);
};
